<template>
  <div id="app">
    <Header
      name="NB Carnes"
      :navLinks="[
        {
          name: 'Início',
          link: '#home',
          dropdown: false,
        },

        {
          name: 'Sobre',
          link: '#about',
          dropdown: false,
        },

        {
          name: 'Princípios',
          link: '#principles',
          dropdown: false,
        },

        {
          name: 'Galeria',
          link: '#galery',
          dropdown: false,
        },
        {
          name: 'Área Restrita',
          link: 'https://nbcarnes.com.br/sistema/view/login.php',
          dropdown: false,
        },
      ]"
    />
    <router-view></router-view>
    <Whatsapp />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/includes/header.vue";
import Footer from "./components/includes/footer.vue";
import Whatsapp from "./components/includes/whats.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Whatsapp,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Quicksand:400,500,700");
html {
  scroll-behavior: smooth;
}
#app {
  font-family: "Quicksand", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #eeeaea;
  background-color: #eeeaea;
}

body::-webkit-scrollbar {
  width: 7px; /* width of the entire scrollbar */
}

body::-webkit-scrollbar-track {
  background: #2f2f2f; /* color of the tracking area */
}

body::-webkit-scrollbar-thumb {
  background-color: rgb(70, 70, 69); /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid rgb(70, 70, 69); /* creates padding around scroll thumb */
}
</style>
